(() => {
  const root = document.getElementById('replo-fullpage-element');
  if (!root) return;
  root.querySelectorAll('[data-alignura-faq]').forEach(button => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.closest('[data-replo-collapsible]').setAttribute('data-state', expanded ? 'open' : 'closed');
      document.getElementById(button.getAttribute('aria-controls')).hidden = !expanded;
    });
  });
})();
